module.exports = __webpack_public_path__ + "img/cch3.c8edb311.jpg";